import styled from "styled-components";

const Wrapper = styled.div`
    margin-top: 1.5rem;
    .filters{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        margin-top: 1rem;
        margin-bottom: .5rem;
        gap: .5rem;
        flex-wrap: wrap;
        .datefilter{
            border: 1px solid rgba(0, 0, 0, .2);
            border-radius:10px;
            min-width: 220px;
        }
    }
    .record-summary{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 1rem;
        margin-bottom: .5rem;
        gap: .5rem;
        .button-group{
            display: flex;
            flex-wrap: wrap;
            justify-content: end;
            gap: 1rem;
        }
    }
    .table-container{
        width: 100%;
        overflow-x: auto;
        table{
            min-width: 1100px;
            width: 100%;
            border-collapse: collapse;
            thead{
                border: 1px solid rgba(0, 0, 0, .6);
                border-radius: 10px;
            }
            td, th{
                text-align: center;
                padding: 15px 5px;
                width: 10%;
            }
            tbody tr:first-child {
                margin-top: 20px;
                width: 100%;
            }
        }
    }
    .user-links{
        display: flex;
        align-items: center;
        gap: 5px;
        width: 200px;
        justify-content: center;
        .profileIcon {
            width: 16px;
            height: 16px;
            stroke: blue;
            fill: blue;
            margin-left: 5px;
        }
    }
 `;

export default Wrapper;